import React, { useEffect, useRef, useState } from 'react';
import '../styles/About.css'
import { FaShieldAlt, FaHandshake, FaAward } from "react-icons/fa";

export default function About() {
    const [isVisible, setIsVisible] = useState(false);
    const [isVisibleTxt, setIsVisibleTxt] = useState(false);
    const sectionRef = useRef(null);
    const txtRef = useRef(null);

    useEffect(() => {
        // eslint-disable-next-line
        const section = sectionRef.current;
        const txt = txtRef.current;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.2 }
        );

        const observerTxt = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisibleTxt(true);
                }
            },
            { threshold: 0.2 }
        );

        if (section) observer.observe(section);
        if (txt) observerTxt.observe(txt);

        return () => {
            if (section) observer.unobserve(section);
            if (txt) observerTxt.unobserve(txt);
        };
    }, []);

    return (
        <section className="abt-section" id="about">
            <div className="abt-container">
                <div 
                    className={`abt-img-wrapper ${isVisible ? 'animate-fade-in-up' : ''}`}
                    ref={sectionRef}
                >
                    <div className="abt-img"></div>
                    <div className="abt-img-accent"></div>
                </div>
                <div 
                    className={`abt-txt ${isVisibleTxt ? 'animate-slide-in-left' : ''}`}
                    ref={txtRef}
                >
                    <h2>About WASA</h2>
                    <p>
                        <strong>Work And Study Abroad</strong> is a comprehensive global services firm offering international job placement, study placement, immigration consultancy, career guidance, and visa application assistance. 
                    </p>
                    <p>
                        We facilitate seamless transitions for individuals pursuing opportunities abroad, ensuring success and fulfillment in their careers and education.
                    </p>
                    <blockquote>
                        Our Vision: To be Africa's leading international immigration consultant.
                    </blockquote>
                    
                    <div className="abt-principles">
                        <div className="principle-item">
                            <FaShieldAlt className="principle-icon" />
                            <h4>Integrity</h4>
                            <p>We operate with transparency</p>
                        </div>
                        <div className="principle-item">
                            <FaHandshake className="principle-icon" />
                            <h4>Trust</h4>
                            <p>Client-focused approach</p>
                        </div>
                        <div className="principle-item">
                            <FaAward className="principle-icon" />
                            <h4>Excellence</h4>
                            <p>Delivering results</p>
                        </div>
                    </div>
                    
                    <div className="abt-stats">
                        <div className="stat-item">
                            <div className="stat-number">500+</div>
                            <div className="stat-label">Clients Placed</div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-number">30+</div>
                            <div className="stat-label">Countries</div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-number">Excellent</div>
                            <div className="stat-label">Success Rate</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}